export default __webpack_public_path__ + "static/media/file-download.a4360969.svg";